import { forwardRef } from "react";

import dynamic from "next/dynamic";

import { DialogProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
const DynamicDashboardDialog = dynamic(() => import("./DashboardDialogSsr").then((mod) => mod.DashboardDialogSsr), {
  ssr: false,
});

// Wrap dynamic component with forwardRef and pass ref as forwardedRef prop
// This is necessary because next/dynamic doesn't properly forward refs
export const DashboardDialog = forwardRef<HTMLDivElement, DialogProps>((props, ref) => (
  <DynamicDashboardDialog {...props} forwardedRef={ref} />
));

DashboardDialog.displayName = "DashboardDialog";
